import React, { Component } from 'react';
import { ThreeBounce } from 'better-react-spinkit';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Api from './Config';

const md5 = require('js-md5');

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      username: '',
      password: '',
      message: '',
      loggedIn: false,
      role: 0,
      redirectUrl: null,
      isRedirectUrlAdmin: null,
    };
  }

  componentDidMount() {
    const UID = localStorage.getItem('UID');
    if (UID) {
      Api.request('VALIDATE_UID', { UID })
        .then((data) => {
          if (data.RESULT == 'SUCCESS') {
            this.setState({ loggedIn: true, IS_ADMIN: data.IS_ADMIN, role: data.ROLE });
          }
        })
        .catch((err) => {});
    }

    if (this.isSessionTimeout()) {
      this.setState({
        loading: false,
        message: 'Your session has timed out please login again.',
        redirectUrl: this.props.history.location.state.from.pathname,
        isRedirectUrlAdmin: this.props.history.location.state.isAdminPage,
      });
      window.history.replaceState({}, document.title);
    }
  }

  tryLogin() {
    this.setState({ loading: true, message: '' });
    Api.request('LOGIN', {
      USERNAME: this.state.username,
      PASSWORD: md5(this.state.password),
    })
      .then((data) => {
        if (data.RESULT == 'FAIL') {
          const errorMessage = data.ERROR ? data.ERROR : 'Invalid username or password.';
          this.setState({ loading: false, message: errorMessage });
        } else {
          localStorage.setItem('UID', data.UID);
          this.setState({ loggedIn: true, IS_ADMIN: data.IS_ADMIN, role: data.ROLE });
          localStorage.setItem('username', data.username);
          localStorage.setItem('app_code', data.app_code);
          localStorage.setItem('ROLE', data.ROLE);
          localStorage.setItem('cluster_id', data.cluster_id);
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        throw err;
      });
  }

  isSessionTimeout() {
    return this.props.history.location.state && this.props.history.location.state.from.pathname;
  }

  render() {
    if (this.state.loggedIn == true && this.state.IS_ADMIN == 'YES') {
      if (this.state.redirectUrl && this.state.isRedirectUrlAdmin) {
        return <Redirect to={this.state.redirectUrl} />;
      }

      return <Redirect to="/RegisterDoctor" />;
    }

    if (this.state.loggedIn == true) {
      if (this.state.role == 2) {
        // return <Redirect to="/hl7Review" />;
      }

      if (this.state.redirectUrl && !this.state.isRedirectUrlAdmin) {
        return <Redirect to={this.state.redirectUrl} />;
      }

      return <Redirect to="/patients" />;
    }

    return (
      <div className="container container-fluid">
        <h2
          style={{
            textAlign: 'center',
          }}
          className="col-md-4 col-md-offset-4 well"
        >
          Provider Office Portal
        </h2>
        <div className="row panel">
          <div className="col-md-4 col-md-offset-4">
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {this.state.loading && <ThreeBounce />}
              <div className="alert-danger">{this.state.message} </div>
            </div>
            <form>
              <div className="form-group">
                <label>Username</label>
                <input
                  value={this.state.username}
                  onChange={(e) => {
                    this.setState({ username: e.target.value });
                  }}
                  type="text"
                  className="form-control"
                  id="username"
                  placeholder="username"
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  value={this.state.password}
                  onChange={(e) => {
                    this.setState({ password: e.target.value });
                  }}
                  type="password"
                  className="form-control"
                  id="exampleInputPassword1"
                  placeholder="Password"
                />
              </div>
            </form>
            <div
              style={{
                textAlign: 'center',
              }}
            >
              <button
                disabled={this.state.loading}
                onClick={() => {
                  this.tryLogin();
                }}
                className="btn btn-primary col-xs-12"
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
